"use client"

import styled from "@emotion/styled"
import { IconButton } from "@mui/material"
import { Attribute, Station } from "api"
import { AppType, useAppType } from "contexts/AppTypeProvider"
import { useRouter } from "next/navigation"
import "swiper/css"
import "swiper/css/effect-coverflow"
import "swiper/css/effect-fade"
import { Desktop, Mobile, NewText, XIcon } from "ui"
import SelectedDetails from "./SelectedDetails"
import StyledFilters from "./StyledFilters"

const StyledContainer = styled.div`
  position: relative;
  gap: 13px;
  background: rgba(246, 247, 249, 0.3);
  display: flex;
  flex-direction: column;
  height: 100%;
  ${(props) => props.theme.breakpoints.up("md")} {
    box-shadow: 0px 4px 12px 0px #82889433;
    border: 1px solid #153e694d;
    padding: 0px;
    gap: 0px;
    max-height: 670px;
    overflow: auto;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    max-height: 860px;
  }
`

const StyledFiltersGap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex-grow: 1;
`

const TopFlex = styled.div`
  display: flex;
  justify-content: space-between;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 16px;
  }

  ${(props) => props.theme.breakpoints.up("lg")} {
    padding: 24px;
  }
`
type Props = {
  metadata: Attribute[]
  userLoc: {
    lat: number
    lon: number
  } | null
  locations: Station[]
  handleClose?: () => void
}

function SideActions({ metadata, userLoc, locations, handleClose }: Props) {
  const { appType } = useAppType();
  const isPazCharge = appType === AppType.Charge;

  const router = useRouter()
  const handleCloseStaionPopup = () => {
    router.replace('')
  }

  return (
    <StyledContainer>
      <TopFlex>
        <NewText
          component="h2"
          desktopFontSize={18}
          desktopFontWeight={500}
          desktopLineHeight={"23.04px"}
          largeDesktopFontSize={28}
          largeDesktopLineHeight="35.84px"
          mobileFontSize={28}
          mobileLineHeight={"35.84px"}
        >
          {isPazCharge ? "סינון לפי שירותים נוספים" : "סינון לפי"}
        </NewText>
        <Mobile>
          <IconButton onClick={handleClose}>
            <XIcon />
          </IconButton>
        </Mobile>
      </TopFlex>

      <StyledFiltersGap>
        <StyledFilters metadata={metadata} handleClose={handleClose} />
      </StyledFiltersGap>
      <Desktop>
        <SelectedDetails locations={locations} userLoc={userLoc} handleClose={handleCloseStaionPopup} />
      </Desktop>
    </StyledContainer>
  )
}

export default SideActions
